// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"31bf01c4","530":"c5bd5274","590":"615bab1a","779":"1bd504f1","926":"60d8a2c1"}[chunkId] + ".chunk.css";
};